module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-runtime/core-js/is-iterable.js
// module id = 1002
// module chunks = 0